@if (workspaceId) {
  <div class="row pane-container">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <h2>{{ 'label_step_1_download_template' | translate }}</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div>{{ 'label_step_1_download_template_details' | translate }}</div>
        </div>
      </div>

      <div class="row py-1">
        <div class="col-12">
          <button class="btn button-link-style" (click)="downloadTemplate()">
            {{ 'label_download_template' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <h2 class="margin-top">{{ 'label_step_2_upload_xlsx' | translate }}</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="margin-bottom">{{ 'label_step_2_upload_xlsx_details' | translate }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <form [formGroup]="formBulk" (ngSubmit)="createBulkDigitalProperty()">
            <app-common-file-dropbox
              [form]="formBulk"
              [acceptedFileTypes]="ACCEPTED_FILE_TYPES"
              [fileValid]="fileValid"
              [fileUploaded]="fileUploaded"
              [fileUploadedMessage]="FILE_UPLOADED_MESSAGE"
              [acceptedFileError]="ACCEPTED_FILE_ERROR"
              (emitFile)="inputFile($event)"
              (clickedValidate)="validate()"
              [fileDataError]="FILE_DATA_ERROR"
              (rebuildForm)="buildForm()"
            >
              <div class="table-wrapper" errorTable>
                @if (fileValid === false) {
                  <app-ngb-table [config]="tableConfig" [data]="tableData"></app-ngb-table>
                }
              </div>
            </app-common-file-dropbox>

            <div class="row margin-top-lg">
              @if (modalMode) {
                <div class="d-flex gap-2">
                  <button class="btn btn-primary" type="submit" [disabled]="!fileValid">
                    {{ 'label_add_assets' | translate }}
                  </button>
                  <button class="btn btn-outline-primary" type="reset" (click)="onCancel()">
                    {{ 'form_cancel' | translate }}
                  </button>
                </div>
              } @else {
                <div class="col-8 d-flex card-button-wrapper">
                  <button class="btn btn-outline-primary" type="reset" (click)="onCancel()">
                    {{ 'form_cancel' | translate }}
                  </button>
                  <button class="btn btn-primary ms-auto" type="submit" [disabled]="!fileValid">
                    {{ 'label_add_properties' | translate }}
                  </button>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}
